import _ from 'lodash';

class TableGridCheckboxCellController {
  constructor() {
    this.name = 'tableGridCheckboxCell';
  }

  toggleCheckbox(){
    this.rowsSelected =  _.size(this.metaData[this.options.dataSet].selectedValues);
  }

}

export default TableGridCheckboxCellController;



// WEBPACK FOOTER //
// ./app/components/tableGridCheckboxCell/tableGridCheckboxCell.controller.js